import { Text, Flex } from '@chakra-ui/react'

export default function Header({ children }: WithChildren) {
  return (
    <Flex flexDirection="column" justifyContent="center">
      <Text fontSize="xl" fontWeight="650" letterSpacing="-0.02em">
        {children}
      </Text>
    </Flex>
  )
}
